import axios from 'axios';

class ApiService {
    constructor() {
        this.ROOT_URL = process.env.API_URL;
    }

    getAuthHeaders() {
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
        };
    }

    async getResource(endpoint) {
        try {
            const response = await axios.get(`${this.ROOT_URL}${endpoint}`, { headers: this.getAuthHeaders() });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async postResource(endpoint, data) {
        try {
            const response = await axios.post(`${this.ROOT_URL}${endpoint}`, data, { headers: this.getAuthHeaders() });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async putResource(endpoint, data) {
        try {
            const response = await axios.put(`${this.ROOT_URL}${endpoint}`, data, { headers: this.getAuthHeaders() });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteResource(endpoint) {
        try {
            const response = await axios.delete(`${this.ROOT_URL}${endpoint}`, { headers: this.getAuthHeaders() });
            return response;
        } catch (error) {
            throw error;
        }
    }
}

const apiService = new ApiService();
export default apiService;



/** WEBPACK FOOTER **
 ** ./src/services/apiService.js
 **/